module.exports = __webpack_public_path__ + "static/media/neverswap-logo.png:Zone.0abc6d39.Identifier";